const youtube = ref(null)
const ready = ref(false)

function initializeYoutube() {
  if (!ready.value) {
    let tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'
    let firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

    window.onYouTubeIframeAPIReady = function onYoutubeIframeAPIReady() {
      youtube.value = window.YT
      ready.value = true
    }
  }
}

export function useYoutube() {
  onMounted(() => initializeYoutube())
  return { youtube, ready }
}
